<template>
  <div class="homeContainer">
    <h1>
      <span><img src="/images/home_ttl.svg" alt="万葉歌碑データベース"/></span>
    </h1>
    <ul>
      <li>
        <router-link router-link v-bind:to="{ name: 'KahiMap' }"
          ><img src="/images/home_btn_map.svg" alt="地図から探す"
        /></router-link>
      </li>
      <li>
        <router-link v-bind:to="{ name: 'KahiList' }"
          ><img src="/images/home_btn_list.svg" alt="一覧から探す"
        /></router-link>
      </li>
      <li class="aboutLink">
        <router-link v-bind:to="{ name: 'About' }"
          >万葉歌碑データベースについて &gt;</router-link
        >
      </li>
    </ul>
  </div>
</template>

<script lang="ts" src="./AppHome.ts"></script>
<style scoped lang="scss" src="./AppHome.scss"></style>
